jQuery(document).ready(function($){
    if ( $('.nf-testimonial-slider-block') ) {
        $('.nf-testimonial-slider-block .nf-testimonial-slider-block__wrapper').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: '',
            nextArrow: '<button><svg width="68" height="24" viewBox="0 0 68 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.184 23.4C52.144 21.352 53.072 19.56 53.968 18.024C54.928 16.488 55.856 15.208 56.752 14.184H0.784001V10.152H56.752C55.856 9.064 54.928 7.752 53.968 6.216C53.072 4.68 52.144 2.92 51.184 0.935998H54.544C58.576 5.608 62.8 9.064 67.216 11.304V13.032C62.8 15.208 58.576 18.664 54.544 23.4H51.184Z" fill="#F07361"/></svg></button>',
            appendArrows: $('.nf-testimonial-slider-block__nav'),
            appendDots: $('.nf-testimonial-slider-block__nav'),
            fade: true
        });
    }
});